import { render, staticRenderFns } from "./device_history_analysis.vue?vue&type=template&id=c2de0376&scoped=true"
import script from "./device_history_analysis.vue?vue&type=script&lang=js"
export * from "./device_history_analysis.vue?vue&type=script&lang=js"
import style0 from "./device_history_analysis.vue?vue&type=style&index=0&id=c2de0376&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2de0376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2de0376')) {
      api.createRecord('c2de0376', component.options)
    } else {
      api.reload('c2de0376', component.options)
    }
    module.hot.accept("./device_history_analysis.vue?vue&type=template&id=c2de0376&scoped=true", function () {
      api.rerender('c2de0376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_history_analysis.vue"
export default component.exports